import React from "react";

export default function Dropdown({
  label,
  options = [],
  value,
  onChange,
  placeholder = "Select option",
  className = "w-full",
}) {
  return (
    <div className={` ${className} `}>
      {label && (
        <label className="block mb-1 text-sm font-medium text-slate-700 dark:text-slate-300">
          {label}
        </label>
      )}

      <div className="relative">
        <select
          value={value}
          onChange={(e) => onChange(e.target.value)}
          className="
            appearance-none w-full px-3 py-2 pr-10 rounded-lg
            bg-white dark:bg-slate-800 
            border border-slate-300 dark:border-slate-700
            text-slate-800 dark:text-white
            focus:ring-2 focus:ring-blue-500 outline-none
          "
        >
          <option value="All Rating">{placeholder}</option>

          {options.map((item, index) => (
            <option key={index} value={item.value}>
              {item.label}
            </option>
          ))}
        </select>

        {/* Chevron Icon */}
        <svg
          className="w-5 h-5 absolute right-3 top-1/2 -translate-y-1/2 text-slate-500 pointer-events-none"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          viewBox="0 0 24 24"
        >
          <path d="M19 9l-7 7-7-7" />
        </svg>
      </div>
    </div>
  );
}
